import React, { Component } from "react";
import { Grid, GridColumn, GridToolbar } from '@progress/kendo-react-grid';
import { Button } from "@progress/kendo-react-buttons";
import axios from 'axios';
import { withState } from "./with-state";
import GridLoading from "../../Loaders/GridLoading";
import { parseDate } from '@telerik/kendo-intl';
import {orderBy} from '@progress/kendo-data-query';
import { FilterDateString } from "../../Inputs/FilterDateString";
import BlendedIndexPopup from './BlendedIndexPopup';
import InputDateFilterCell from "../../Inputs/InputDateFilterCell";
const StatefulGrid = withState(Grid);

const cloneProduct = (product) => ({ ...product });

class BlendedIndex extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            blendedIndexes: [],
            blendedIndexesCompositions: [],
            gridFilter: undefined,
            filterable: props.styleSettings.showFilters,
            sort: [{ field: 'SortOrder', dir: 'asc' }],
            fileDownload: []
        }

    }

    componentDidMount = () => {
        this.getBlendedIndexes();
        this.getBlendedIndexesCompositions();
    }

    getBlendedIndexes = () => {
        this.setState({ refreshText: 'Loading...', reportSelected: false, reportSelect: '', });
        var blendedIndexes = [];

        const headers = { 'authorization': 'Bearer '.concat(this.props.idToken) };

        axios(`api/getBlendedIndexes`, {
            method: 'GET',
            params: { company: this.props.user.company },
            headers: headers,
        })
            .then(response => {

                response.data.data.forEach(blendedIndex => {

                    if (blendedIndex.DateCreated) {
                        blendedIndex.DateCreated = this.getDate(blendedIndex.DateCreated, true);
                    }

                    blendedIndex.EntityDescription = blendedIndex.EntityDescription.replace(/\\n/g, '\n')
                    blendedIndexes.push(blendedIndex)

                })
                this.setState({ blendedIndexes: blendedIndexes })

            })
            .catch(err => {
                console.error(err);
                this.setState({ refreshText: '' });
            })
    }

    getBlendedIndexesCompositions = () => {
        this.setState({ refreshText: 'Loading...', reportSelected: false, reportSelect: '', });
        var blendedIndexesCompositions = [];

        const headers = { 'authorization': 'Bearer '.concat(this.props.idToken) };

        axios(`api/getBlendedIndexesCompositions`, {
            method: 'GET',
            params: { company: this.props.user.company },
            headers: headers,
        })
            .then(response => {

                response.data.data.forEach(blendedIndexComposition => {

                    if (blendedIndexComposition.DateCreated) {
                        blendedIndexComposition.DateCreated = this.getDate(blendedIndexComposition.DateCreated, true);
                    }
                    if (blendedIndexComposition.AsOfDate) {
                        blendedIndexComposition.AsOfDate = this.getDate(blendedIndexComposition.AsOfDate, true);
                    }

                    blendedIndexComposition.EntityDescription = blendedIndexComposition.EntityDescription.replace(/\\n/g, '\n')
                    blendedIndexesCompositions.push(blendedIndexComposition)

                })
                this.setState({ data: blendedIndexesCompositions.map(cloneProduct), blendedIndexesCompositions: blendedIndexesCompositions, refreshText: '' })

            })
            .catch(err => {
                console.error(err);
                this.setState({ refreshText: '' });
            })
    }

    selectionChange(event, gFiles) {
        gFiles.forEach(item => {
            if (item.BlendID !== event.dataItem.BlendID) {
                item.selected = false
            }
        });
        event.dataItem.selected = !event.dataItem.selected;
        var selectedFiles = [];
        for (let i = 0; i < gFiles.length; i++) {
            if (gFiles[i].selected) {
                selectedFiles.push(gFiles[i]);
            }
        }
        this.setState({ fileDownload: selectedFiles }, () => { this.forceUpdate(); });
        if (selectedFiles.length > 0) {
            this.setState({ fileSelected: true });
        }
        else {
            this.setState({ fileSelected: false });
        }
        this.forceUpdate();
    }

    headerSelectionChange = (event, gFiles) => {
        const checked = event.syntheticEvent.target.checked;
        gFiles.forEach(item => item.selected = checked);
        var selectedFiles = [];
        for (let i = 0; i < gFiles.length; i++) {
            if (gFiles[i].selected) {
                selectedFiles.push(gFiles[i]);
            }
        }
        this.setState({ fileDownload: selectedFiles });
        if (selectedFiles.length > 0) {
            this.setState({ fileSelected: true });
        }
        else {
            this.setState({ fileSelected: false });
        }
        this.forceUpdate();
    }

    getDate = (sqlDate, isUTC) => {
        var d = parseDate(sqlDate, "yyyy-MM-ddTHH:mm:ss.SSSXXX");
        var utc = new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
        if (isUTC)
            return utc;
        else
            return d;
    }

    headerCellRender = (thElement, cellProps) => {
        if (thElement !== null) {
            if (cellProps.field === 'selected')
                return (
                    <div />
                );
            else {
                return thElement
            }
        }
        else {
            return thElement;
        }
    }

    refreshBlendedIndexes = () => {
        this.setState({ fileDownload: [], fileSelected: false });
        this.getBlendedIndexes();
        this.getBlendedIndexesCompositions();
    }

    onDeleteComposition = (e) => {

        var confirm = window.confirm("Are you sure you want to delete this?");
        
        if (confirm) {
            const headers = { 'authorization': 'Bearer '.concat(this.props.idToken) };
            var payload = {
                blendedIndexCompositions: this.state.fileDownload,
                company: this.props.user.company,
            };
            axios.post('api/deleteBlendedIndexCompositions', payload, { headers }).then(response => {
                if (response.data.code === 200) {
                    this.setState({ fileDownload: [] });
                    this.setState({ fileSelected: false });
                    this.getBlendedIndexes();
                    this.getBlendedIndexesCompositions();
                }
                else {
                    alert("Error: Could not be deleted.");
                    this.setState({ fileDownload: [] });
                    this.setState({ fileSelected: false });
                    this.getBlendedIndexes();
                    this.getBlendedIndexesCompositions();
                }
            }).catch(e => console.log(e));
        }
    }
    
    onDelete = (e) => {
        
        var confirm = window.confirm("Are you sure you want to delete the blended index? This will also delete all associated blended index compositions.");

        if (confirm) {
            const headers = { 'authorization': 'Bearer '.concat(this.props.idToken) };
            var payload = {
                blendedIndexes: this.state.fileDownload,
                company: this.props.user.company,
            };
            axios.post('api/deleteBlendedIndexes', payload, { headers }).then(response => {
                if (response.data.code === 200) {
                    this.setState({ fileDownload: [] });
                    this.setState({ fileSelected: false });
                    this.getBlendedIndexes();
                    this.getBlendedIndexesCompositions();
                }
                else {
                    alert("Error: Could not be deleted.");
                    this.setState({ fileDownload: [] });
                    this.setState({ fileSelected: false });
                    this.getBlendedIndexes();
                    this.getBlendedIndexesCompositions();
                }
            }).catch(e => console.log(e));
        }
    }

    processData = () => {
      const { data, sort, gridFilter } = this.state;

      // first sort
      let sorted = orderBy(data, sort);

      // then filter using FilterDateString
      let filtered = gridFilter ? FilterDateString.filterData(sorted, gridFilter) : sorted;

      return filtered;
    };

    render() {
        return (
            <div className='blendedIndexes'>

                <StatefulGrid data={this.processData(this.state.data)}
                    selectedField='selected'
                    onSelectionChange={(e) => this.selectionChange(e, this.state.blendedIndexesCompositions)}
                    onRowClick={(e) => this.selectionChange(e, this.state.blendedIndexesCompositions)}
                    onHeaderSelectionChange={(e) => this.headerSelectionChange(e, this.state.blendedIndexesCompositions)}
                    headerCellRender={this.headerCellRender}
                    filterable={this.state.filterable}
                    filter={this.state.gridFilter}
                    onFilterChange={(e)=>{this.setState({gridFilter:e.filter})}}
                    resizable
                >
                    <GridToolbar>
                        <Button icon='refresh' title='Refresh' onClick={this.refreshBlendedIndexes}>{this.state.refreshText}</Button>
                        <Button icon='filter' title='Filter' onClick={(e) => this.setState({ filterable: !this.state.filterable })}>Filter</Button>
                        <BlendedIndexPopup idToken={this.props.idToken} uploadMethod={this.refreshBlendedIndexes} files={this.state.blendedIndexesCompositions} blendedIndexes={this.state.blendedIndexes} company={this.props.user.company} user={this.props.user} uploadUser={this.props.uploadUser} type='reportStaticContent' button={<Button className="docButton" icon="upload">New</Button>} />
                        {this.props.uploadUser.role === 'admin' && (<BlendedIndexPopup idToken={this.props.idToken} blendedIndexEdit={this.state.fileDownload[0]} uploadMethod={this.refreshBlendedIndexes} files={this.state.blendedIndexesCompositions} blendedIndexes={this.state.blendedIndexes} company={this.props.user.company} user={this.props.user} uploadUser={this.props.uploadUser} button={<Button className="docButton" disabled={this.state.fileDownload.length !== 1} icon='edit'>Edit</Button>} />)}
                        {this.props.uploadUser.role === 'admin' && (<Button className="docButton" disabled={!this.state.fileSelected} onClick={this.onDelete} icon='delete'>Delete Blend Index</Button>)}
                        {this.props.uploadUser.role === 'admin' && (<Button className="docButton" disabled={!this.state.fileSelected} onClick={this.onDeleteComposition} icon='delete'>Delete Blend Index Composition</Button>)}
                    </GridToolbar>
                    <GridColumn
                        width='150px'
                        field="BlendID"
                        title="ID"
                        headerClassName='gridHeader'
                        cell={(props) =>
                            <td>
                                {props.dataItem.BlendID}
                            </td>
                        }
                    />
                    <GridColumn
                        field="EntityDescription"
                        title="Description"
                        headerClassName='gridHeader'
                        cell={(props) =>
                            <td>
                                {props.dataItem.EntityDescription}
                            </td>
                        }
                    />
                    <GridColumn
                        width='150px'
                        field="DateCreated"
                        title="Date Created"
                        headerClassName='gridHeader'
                        filterCell={InputDateFilterCell}
                        filter="date"
                        format="{0:d}"
                    />
                    <GridColumn
                        width='150px'
                        field="IndexEntityCode"
                        title="Index Entity Code"
                        headerClassName='gridHeader'
                        cell={(props) =>
                            <td>
                                {props.dataItem.IndexEntityCode}
                            </td>
                        }
                    />
                    <GridColumn
                        width='150px'
                        field="Weighting"
                        title="Weighting"
                        headerClassName='gridHeader'
                        cell={(props) =>
                            <td>
                                {props.dataItem.Weighting}
                            </td>
                        }
                    />
                    <GridColumn
                        width='200px'
                        field="AsOfDate"
                        title="As of Date"
                        headerClassName='gridHeader'
                        filterCell={InputDateFilterCell}
                        filter="date"
                        format="{0:d}"
                    />
                </StatefulGrid>
                {this.state.refreshText && <GridLoading gridClass='webRep' />}
            </div>
        );
    }

}

export default BlendedIndex;